import dayjs from 'dayjs';
import translate from '@/utils/translate';
import {MONTH_SHORT_DAY_YEAR_FORMAT} from '@/config/timeFormats';
import useProjectsQuery from '@/hooks/content-studio/use-projects-query';

export function calculateCompletionPercentage(
  filesCount: number,
  filesCompletedCount: number
) {
  if (
    typeof filesCount !== 'number' ||
    typeof filesCompletedCount !== 'number' ||
    filesCount === 0
  ) {
    return undefined;
  }
  return (filesCompletedCount / filesCount) * 100;
}

export function createProgressString(
  filesCount: number,
  filesCompletedCount: number
) {
  const completionPercentage = calculateCompletionPercentage(
    filesCount,
    filesCompletedCount
  );
  if (typeof completionPercentage !== 'number') {
    return '';
  }
  return translate('project-processing', {
    completionPercentage: Math.round(completionPercentage),
    filesCompletedCount,
    filesCount,
  });
}

export function useDefaultProjectName(featureName: string) {
  return `${featureName} - ${dayjs().format(MONTH_SHORT_DAY_YEAR_FORMAT)}`;
}
